// @mui
import { GlobalStyles } from "@mui/material"
import { useTheme } from "@mui/material/styles"

// ----------------------------------------------------------------------

export default function StyledNotistack() {
  const theme = useTheme()

  const inputGlobalStyles = (
    <GlobalStyles
      styles={{
        "#root": {
          ".notistack-MuiContent": {
            width: "100%",
            padding: `0 ${theme.spacing(1)}`,
            margin: theme.spacing(0.25, 0),
            boxShadow: theme.shadows[10],
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.paper,
            fontWeight: theme.typography.fontWeightMedium,
            [theme.breakpoints.up("md")]: {
              minWidth: 240,
            },
            minHeight: 56,
          },
        },
      }}
    />
  )

  return inputGlobalStyles
}
